import { createSelector } from 'reselect';

import * as c from 'constants/UI';
import { RootState } from 'reducers';

import { getProductGroupByID } from '../productGroupsDB';

interface GridDisplayState {
  opened: boolean;
  view: typeof c.displayView[keyof typeof c.displayView];
  currentProductGroup: string;
  shouldGridUpdate: boolean;
}

const initialState: GridDisplayState = {
  opened: true,
  view: c.displayView.main,
  currentProductGroup: '0',
  shouldGridUpdate: false,
};

const reducer = (state = initialState, { type, payload }): GridDisplayState => {
  switch (type) {
    case c.OPEN_GRID_VIEW:
      return { ...state, opened: true };
    case c.CLOSE_GRID_VIEW:
      return { ...state, opened: false };
    case c.SET_GRID_VIEW:
      return { ...state, view: payload };
    case c.SET_PRODUCT_GROUP:
      return { ...state, currentProductGroup: payload };
    case c.SET_GRID_SHOULD_UPDATE:
      return { ...state, shouldGridUpdate: payload };
    default:
      return state;
  }
};

export default reducer;

export const getSelectedProductGroupID = (state: RootState) =>
  state.UI.gridDisplay.currentProductGroup;

export const getSelectedProductGroup = (state: RootState) =>
  getProductGroupByID(getSelectedProductGroupID(state))(state);

export const getIsRootProductGroupSelected = (state: RootState) =>
  state.UI.gridDisplay.currentProductGroup === '0';

export const getGridIsOpened = createSelector(
  (state: RootState) => state.UI.gridDisplay.opened,
  () => localStorage.getItem('viewMode'),
  (opened, mode) => (mode ? mode === 'grid' && opened : opened),
);
export const getGridView = (state: RootState) => state.UI.gridDisplay.view;

export const getIsRetailView = (state: RootState) => !getGridIsOpened(state);

export const getShouldGridUpdate = (state: RootState) =>
  state.UI.gridDisplay.shouldGridUpdate;
